<header>
  <h1 class="modal-title">Form Info</h1>
  <button
    (click)="close()"
    aria-label="Close"
    class="modal-close"
    inlineSVG="/assets/icons/close.svg"
  ></button>
</header>

<h4>Form Details</h4>
<fl-data-table
  [compact]="true"
  [table]="formDetails"
></fl-data-table>

<h4>Usage Details</h4>
<fl-data-table
  [compact]="true"
  [table]="[{
    header: 'Workflow Templates',
    value: templateWorkflowCount
  }, {
    header: 'Active Workflows',
    value: activeWorkflowCount
  }, {
    header: 'Data Requests',
    value: dataRequestCount
  }]"
></fl-data-table>

<h4>Activity Log</h4>
<ul class="activity-log">
  <li *ngFor="let activity of activities" class="activity">
    <div class="details">
      <span class="author">
        <span class="name">{{activity.author.full_name}}</span>
        &lt;{{activity.author.email}}&gt;
      </span>
      <div>{{form_activity_string(activity)}}</div>

      <ng-container [ngSwitch]="activity.type">
        <ng-container *ngSwitchCase="'attribute'">
          <ul class="changed-properties">
            <li *ngFor="let key of changed_properties_keys(activity.changed_properties)" class="property">
                <span class="key">"{{key}}"</span>
                from <span class="value">{{activity.changed_properties[key].from | json}}</span>
                to <span class="value">{{activity.changed_properties[key].to | json}}</span>
            </li>
          </ul>
        </ng-container>

        <ng-container *ngSwitchCase="'insert'">
          <ul class="changed-properties">
            <li *ngFor="let key of changed_properties_keys(activity.changed_properties)" class="property">
              <span class="key">"{{key}}"</span>: <span class="value">"{{activity.changed_properties[key]}}"</span>
            </li>
          </ul>
        </ng-container>

        <ng-container *ngSwitchCase="'delete'">
          <ul class="changed-properties">
            <li *ngFor="let key of changed_properties_keys(activity.changed_properties)" class="property">
              <ng-container *ngIf="key === 'elements'">
                <span class="key">"Elements"</span>: <span class="value">"{{activity.changed_properties[key].length}} child elements removed"</span>
              </ng-container>

              <ng-container *ngIf="key !== 'elements'">
                <span class="key">"{{key}}"</span>: <span class="value">"{{activity.changed_properties[key]}}"</span>
              </ng-container>
            </li>
          </ul>
        </ng-container>

        <ng-container *ngSwitchDefault>
<pre>{{activity.changed_properties | json}}</pre>
        </ng-container>
      </ng-container>
    </div>
    <span class="timestamp">{{activity.created_at | momentDate}}</span>
  </li>
</ul>
